import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://innermap.in',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

export const clearAuth = () => {
  localStorage.removeItem('authToken');
};

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add JWT token to Authorization header for all requests
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Don't force JSON content-type for multipart/form-data so browser sets correct boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
      if (config.headers && typeof config.headers.delete === 'function') {
        config.headers.delete('Content-Type');
        config.headers.delete('content-type');
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only redirect to login for 401 errors on non-login requests
    // This prevents redirect loops when login fails with invalid credentials
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/login');
      if (!isLoginRequest) {
        localStorage.removeItem('authToken');
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
